import type { ReactNode } from "react";
import { openFilePicker, type OpenFilePickerOptions } from "@/lib/native/openFilePicker";

type FileUploadTriggerProps = OpenFilePickerOptions & {
  disabled?: boolean;
  onFilesSelected: (files: File[]) => void;
  children: (open: () => void) => ReactNode;
};

/** Native-safe file picker trigger (replaces hidden input + .click()). */
export function FileUploadTrigger({
  disabled,
  onFilesSelected,
  children,
  ...pickerOptions
}: FileUploadTriggerProps) {
  const open = async () => {
    if (disabled) return;
    const files = await openFilePicker(pickerOptions);
    if (files.length) onFilesSelected(files);
  };

  return <>{children(open)}</>;
}
